import React, { useState } from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../common/textfield/TextInput";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../common/Button";
import { failed, success } from "../common/Toastify";
import { verifiedUserSetPass, userLogin } from "../api/AuthService";
import Lock from '../../assets/images/Lock.png';
import IntservTokenValidation from "../Login/intserv-token-validation";
import { validation, conditionalValidation } from "../../utils/constants";

function VerifiedUserSetPass() {
    const navigate = useNavigate();
    const { state } = useLocation()
    const [btnLoading, setBtnLoading] = useState(false)
    const [apiTokenValidationModalShow, setApiTokenValidationModalShow] = useState(false)
    const username = state?.username;
    const session = state?.session;
    const formik = useFormik({
        initialValues: {
            password: "",
            confirmPass: "",
        },
        validationSchema: Yup.object({
            password: conditionalValidation(
                Yup.string()
                .matches(
                    /^(?!\s)(?!.*\s$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&~])[A-Za-z\d@$!%*#?&~ ]{12,}$/,
                    "Password must be at least 12 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character (@$!%*#?&~). It cannot start or end with a space."
                ),
                {
                    label: "Password",
                    mandatory: true
                }),
            confirmPass: conditionalValidation(
                Yup.string().oneOf([Yup.ref('password'), null], 'Passwords must match'),
                {
                    label: "Confirm Password",
                    mandatory: true
                })
        }),
        onSubmit: (values) => {
            values.confirmPass = values.confirmPass?.trim();
            values.password = values.password?.trim();
            setBtnLoading(true)
            verifiedUserSetPass({ username, session, confirmPass: values.confirmPass }).then(({ data }) => {
                if (data.status === true) {
                    success(data.message);
                    // Check if user is API user by attempting login with new password
                    userLogin({ username: username, password: values.confirmPass }).then((loginRes) => {
                        if (loginRes?.status === true && loginRes?.user?.["custom:group"] === "API") {
                            setApiTokenValidationModalShow(true);
                        } else {
                            navigate("/");
                        }
                    }).catch(() => {
                        navigate("/");
                    });
                } else {
                    failed(data.error);
                }
            }).catch(res => {
                failed(res?.response?.data?.message || res?.response?.data?.message || res.message);
            }).finally(() => setBtnLoading(false));
        },
    });

    return (
        <>
            <form className="custom-form" onSubmit={formik.handleSubmit}>
                <Row>
                    <Col>
                        <TextInput type="password" icon={Lock} keyField={"password"} label={"New Password"} formik={formik} placeholder={"New Password"} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextInput type="password" icon={Lock} keyField={"confirmPass"} label={"Confirm Password"} formik={formik} placeholder={"Confirm Password"} />
                    </Col>
                </Row>
                <div className="btn-wrap" style={{ display: 'flex' }}>
                    <Button type="submit" isLoading={btnLoading}>Submit</Button>
                </div>
            </form>
            {apiTokenValidationModalShow && <IntservTokenValidation modalShow={apiTokenValidationModalShow} handleClose={() => {
                setApiTokenValidationModalShow(false);
                navigate("/");
            }} />}
        </>
    );
}

export default VerifiedUserSetPass;